module.exports = __webpack_public_path__ + "img/6.79711c8f.jpg";